import { defineStore } from "pinia";

export interface AdminToast {
  id: string;
  tone: "success" | "warning" | "error";
  message: string;
}

export const useAdminToastStore = defineStore("admin-toasts", {
  state: (): { toasts: AdminToast[] } => ({ toasts: [] }),
  actions: {
    success(message: string): void {
      this.push("success", message);
    },
    warning(message: string): void {
      this.push("warning", message);
    },
    error(message: string): void {
      this.push("error", message);
    },
    push(tone: AdminToast["tone"], message: string): void {
      this.toasts = [{ id: crypto.randomUUID(), tone, message }, ...this.toasts].slice(0, 4);
    },
    dismiss(id: string): void {
      this.toasts = this.toasts.filter((toast) => toast.id !== id);
    },
  },
});
